import React from 'react'
import classNames from 'classnames'

export default function ({ inline, style }) {
  let css = ''
  if (inline) {
    style = {
      display: 'inline-block',
      position: 'relative',
      width: 20,
      height: 20,
      paddingLeft: 30,
      ...style
    }
    css = 'progress-indicator'
  } else {
    style = {
      width: 70,
      height: 70,
      ...style
    }
  }
  return (
    <div style={style}>
      <div className={classNames('k-loading-mask', { 'k-transparent': inline })}>
        <div className={`k-loading-image ${css}`} />
        <div className='k-loading-color' />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator.js